var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChaingeSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 36,
    viewBox: "0 0 49 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.354 1 9.61 13.396c-3.164 3.289-3.116 8.652 0 11.992 3.116 3.288 8.198 3.288 11.313 0l3.932-4.15 4.793 5.01-3.93 4.148c-2.062 2.125-4.555 3.542-7.191 4.149-2.637.607-3.883.607-6.52 0-2.637-.607-5.13-2.024-7.19-4.15-5.754-6.07-5.754-15.987 0-22.06L11.813 1h9.54zM44.22 5.755c5.707 6.02 5.707 15.94 0 22.01l-6.423 6.78h-9.54l11.17-11.789c3.117-3.29 3.117-8.704 0-11.991l-.193-.198c-3.13-3.09-8.068-3.024-11.12.198l-3.931 4.149-4.795-5.01 3.931-4.149c5.753-6.071 15.149-6.071 20.901 0zm-9.347 9.919c1.294 1.415 1.294 3.641 0 5.058l-2.588 2.733-4.795-5.01 2.637-2.781a3.258 3.258 0 0 1 4.746 0zm-18.121-2.986 4.794 5.008-2.636 2.733a3.18 3.18 0 0 1-4.747 0c-1.342-1.367-1.294-3.643 0-5.01l2.589-2.731z",
    fill: "none",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaingeSymbol);
export default __webpack_public_path__ + "static/media/chainge-symbol.7df5dca4e7a7466a6480435f2b4c933d.svg";
export { ForwardRef as ReactComponent };